import script from "./Plan.vue?vue&type=script&setup=true&lang=js"
export * from "./Plan.vue?vue&type=script&setup=true&lang=js"

import "./Plan.vue?vue&type=style&index=0&id=ce5b99c8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce5b99c8"]])

export default __exports__